/*scroll header*/
$(window).scroll(function() {
  if ($(document).scrollTop() > 700) {
      $('.header_wrapper').addClass('scrolled');
  }
  else{
    $('.header_wrapper').removeClass('scrolled');
  }
});

/*Detect Direction*/
var lastScrollTop = 0;
$(window).scroll(function(event){
   var st = $(this).scrollTop();
   if (st > lastScrollTop){
       // downscroll code
       $('.header_wrapper').addClass('down');
   } else {
      // upscroll code
      $('.header_wrapper').removeClass('down');
   }
   lastScrollTop = st;
});


/*Language Switcher*/
$(".language.is-active").on('click', function() {
    return false;
})

/*More text*/
$(".moretext").on('click', function() {
    $(this).parent().find('.more_text').slideToggle();
    return false;
})

// Form
$("p.open_hide_box").on('click', function() {
    $(this).parent().find('.hide_box').slideToggle();
    return false;
});




/*Open Menu*/
$(".menu_button").on('click', function() {
      if($(this).hasClass('is-active')){
          $("body").css('overflow-y','scroll');
          $(this).removeClass('is-active');
          $('.menu_button').removeClass('is-active');
          $('.headermenu').removeClass('is-active');
          $('.header_wrapper').removeClass('is-active');
        }
        else{
          $(this).addClass('is-active');
          $('.menu_button').addClass('is-active');
          jQuery("body").css('overflow-y','hidden');
          $('.headermenu').addClass('is-active');
          $('.header_wrapper').addClass('is-active');
      }
});


/*Faq*/
$(".faq").on('click', function() {
    $(this).find('.hidden_content').slideToggle();
    if($(this).find('.button').hasClass('active')){
      $(this).find('.button').removeClass('active');
    }else{
      $(this).find('.button').addClass('active');
    }
    return false;
});

/*Product overview*/
$(".openpackaging").on('click', function() {
    $(this).parent().find('.hidden_text').slideToggle();
    if($(this).hasClass('active')){
      $(this).removeClass('active');
    }else{
      $(this).addClass('active');
    }
    return false;
});

/*Gallery*/

          import Swiper, { Navigation, Pagination } from 'swiper';

          const gallery_swi = new Swiper(".gallery_swipe", {
            loop: true,
            spaceBetween: 20,
            grabCursor: true,
            slidesPerView:1.5,
            speed: 1000,
            centeredSlides: false,
            breakpoints: {
             // when window width is >= 0px
             0: {
               slidesPerView:1,
             },
             300: {
               slidesPerView:1,
             },
             // when window width is >= 550px
             550: {
               slidesPerView:1,
             },
             // when window width is >= 1024px
             1024: {
               slidesPerView:1.5,
             },
             // when window width is >= 1200px
             1200: {
               slidesPerView:1.5,
             }
           }
          });

          const product_image_swipe = new Swiper(".product_image_swipe", {
            loop: true,
            spaceBetween: 0,
            grabCursor: false,
            slidesPerView:1,
            speed: 500,
            centeredSlides: true,
            navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
          },
          });

          const project_swipe = new Swiper(".project_swipe", {
            loop: true,
            spaceBetween:35,
            grabCursor: false,
            slidesPerView:3,
            speed:500,
            breakpoints: {
             // when window width is >= 0px
             0: {
               slidesPerView:1,
             },
             300: {
               slidesPerView:1,
             },
             // when window width is >= 768px
             768: {
               slidesPerView:1.5,
             },
             // when window width is >= 1024px
             1024: {
               slidesPerView:2,
             },
             // when window width is >= 1200px
             1200: {
               slidesPerView:3,
             }
           }
          });
